import React, { useState, useEffect, Fragment } from 'react';
import './index.scss';

export default function FetchPriceLoader() {
  return (
    <div className="fetch--bouncing-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
 